var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FEFEFE;}\n\t.st1{fill:#6D90CE;}\n\t.st2{fill:#FEABB9;}\n\t.st3{fill:#FEDEA9;}\n\t.st4{fill:#FEFDFD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,125.2c0,40.9,0,81.8,0,122.8c0,1.7-0.3,2-2,2c-82-0.1-164-0.1-246,0c-1.7,0-2-0.3-2-2 C0.1,166,0.1,84,0,2c0-1.7,0.3-2,2-2c82,0.1,164,0.1,246,0c1.7,0,2.1,0.3,2,2C250,43.1,250,84.2,250,125.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,87.1c0.3,16.7-5,30.3-14.4,42.5c-2.1,2.7-2.1,2.7,0.4,5.2c5.2,5.2,10.5,10.5,15.7,15.7 c1.1,1.1,1.9,1.6,3.2,0.3c1.1-1.1,2-0.7,3.1,0.4c18.2,18.3,36.5,36.5,54.8,54.8c3.2,3.2,3.7,8.2,1.2,11.2 c-3.3,4.1-7.3,4.8-11.8,2.4c-1.3-0.7-2.5-1.6-3.5-2.7c-17.5-17.6-35.1-35.1-52.7-52.6c-1.3-1.3-2.2-2.3-0.3-3.8 c0.8-0.6,0.7-1.4-0.1-2.3c-6.1-6-12.2-12.1-18.2-18.2c-0.9-0.9-1.6-0.9-2.5-0.1c-8.6,7-18.6,11.4-29.4,13 c-16.2,2.4-31.6-0.4-45.7-9.3c-11.5-7.3-19.8-17.2-25.2-29.6c-3.1-7.2-4.9-14.8-5-22.7C27,84,27.5,76.8,29.6,69.8 c2.8-9.2,7.3-17.4,13.6-24.6c6.1-7,13.4-12.4,21.8-16.3c7.8-3.6,16-5.7,24.7-5.9c7.4-0.2,14.7,0.5,21.8,2.6 c7.4,2.3,14.2,5.8,20.3,10.4c10.8,8.2,18.4,18.8,22.7,31.6C156.6,74.2,158,81.1,157.5,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.8,31.5c32.6-0.4,57.5,26.6,57,57.1c-0.6,33.6-26.6,56.7-57.3,56.7c-31,0-58.7-25.8-56.5-61.4 C37.7,56.9,61.4,30.9,92.8,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72,99.5c-1.5,0.3-2.2-0.5-2.7-2.2c-1.5-4.6-0.5-3.7-5.2-3.8c-0.5,0-1,0-1.5,0c-4.3,0.1-3.8-1-5.2,3.8 c-0.6,2-2.9,3-4.7,2.1c-1.1-0.5-0.6-1.4-0.3-2.1c2-5.9,4.1-11.8,6.1-17.7c0.3-0.9,0.8-1.8,1-2.8c0.4-2.4,1.8-2.8,4-2.9 c2.6-0.1,3.6,0.9,4.4,3.2c2.1,6.5,4.4,12.9,6.7,19.3C75.5,99.3,75.3,99.5,72,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.4,95.5c3.2,0,5.8,0,8.5,0c1.5,0,2.8-0.2,2.7,2.1c0,2.1-1.2,1.9-2.6,1.9c-3.7,0-7.5,0-11.2,0 c-3.3,0-4.3-1.5-2.7-4.5c1.2-2.3,2.6-4.4,3.9-6.6c1.7-2.8,3.4-5.5,5.1-8.2c0.3-0.5,1-1.1,0.6-1.8c-0.4-0.6-1.2-0.3-1.9-0.3 c-2.1,0-4.2-0.1-6.2,0c-1.5,0.1-1.9-0.8-1.8-2c0.1-1.1,0.2-2.1,1.8-2c4.2,0.1,8.3,0.1,12.5,0c1.4,0,1.9,0.6,2,2 c0.1,1.9-0.7,3.4-1.6,4.9C124.5,85.5,121.6,90.3,118.4,95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.3,85c3.2,0,6.3,0,9.5,0c1.4,0,2.2,0.4,2.2,1.9c0,1.7-0.8,2.1-2.3,2.1c-6.2,0-12.4-0.1-18.7,0 c-1.4,0-2.1-0.3-2.1-1.9s0.5-2.2,2.1-2.1C87.2,85.1,90.2,85,93.3,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M63.3,78.8c1.2,3.5,2.2,6.5,3.2,9.5c0.1,0.2,0.2,0.4,0.1,0.5c-1.6,1.7-3.6,0.4-5.4,0.7 c-1,0.2-1.2-0.5-0.9-1.4C61.2,85.2,62.2,82.3,63.3,78.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDLogoWhite);
export default __webpack_public_path__ + "static/media/d_logo_white.aa4c529fff20bdd35df270c5d2d44510.svg";
export { ForwardRef as ReactComponent };